import React from "react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from "recharts";
import { Hash } from "lucide-react";
import { Card, chartCommon } from "./FrequencyCharts";

function TopSplit({ title, items, valueClass }) {
  return (
    <div>
      <div className="label-caps">{title}</div>
      <ul className="mt-1 space-y-1">
        {items?.slice().sort((a, b) => b.count - a.count).slice(0, 4).map((e) => (
          <li key={e.label} className="flex items-center justify-between font-body text-xs">
            <span className="text-parchment/70">{e.label}</span>
            <span className={valueClass}>{e.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function DistributionsCard({ sum }) {
  return (
    <div className="lg:col-span-6">
      <Card title="Distributions" icon={Hash} testid="distributions">
        <div className="grid grid-cols-2 gap-3">
          <TopSplit title="Odd / Even" items={sum?.odd_even} valueClass="text-oracle" />
          <TopSplit title="Low / High" items={sum?.low_high} valueClass="text-terminal" />
          <div className="col-span-2">
            <div className="label-caps mt-2">Sum Range</div>
            <div className="font-body text-xs text-parchment/60 mt-1">
              avg <span className="text-oracle">{sum?.average_sum}</span> · range <span className="text-parchment">{sum?.min_sum}–{sum?.max_sum}</span>
            </div>
            <div className="w-full h-24 mt-2">
              <ResponsiveContainer>
                <BarChart data={sum?.sum_distribution || []} margin={{ top: 0, right: 0, left: -25, bottom: 0 }}>
                  <XAxis dataKey="label" {...chartCommon} tick={false} axisLine={false} />
                  <YAxis {...chartCommon} tickLine={false} axisLine={false} width={30} />
                  <Bar dataKey="count" fill="#FFB000" radius={[2, 2, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
